import "bijou/base";

$(document).on("keydown", ".qa-excess-pop-up", function (e) {
  if (e.key === " " || e.which === 32) {
    e.target.click();
    e.preventDefault();
  }
});
